import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Catalogo from "./Catalogo";
import Produto from "./Produto";

export default function Index({ match }) {
  return (
    <div className="content-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/catalogo`} />
        <Route path={`${match.url}/catalogo`} component={Catalogo} />
        <Route
          path={`${match.url}/produto/:id/:grupoDescontoId?`}
          component={Produto}
        />
      </Switch>
    </div>
  );
}
